import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';
@Component({
  template: `
    <ion-list>
      <ion-item class="filterDropDown">
        <ion-label>{{ "favourite" | translate }} <ion-icon name="star" style="font-size: 30px; color: #F1C40F"></ion-icon></ion-label>
        <ion-checkbox item-end color="themeBlue" [checked]="filterType.isFavorite" (click)="updateOption(true, false, false, false)" mode="md"></ion-checkbox>
      </ion-item>
      <ion-item class="filterDropDown">
        <ion-label>{{ "notStarted" | translate }}</ion-label>
        <ion-checkbox item-end color="themeBlue" [checked]="filterType.isNotStarted" (click)="updateOption(false, true, false, false)" mode="md"></ion-checkbox>
      </ion-item>
      <ion-item class="filterDropDown">
        <ion-label>{{ "currentlyPlaying" | translate }}</ion-label>
        <ion-checkbox item-end color="themeBlue" [checked]="filterType.isCurrentlyPlaying" (click)="updateOption(false, false, true, false)" mode="md"></ion-checkbox>
      </ion-item>
      <ion-item class="filterDropDown">
        <ion-label>{{ "fullTime" | translate }}</ion-label>
        <ion-checkbox item-end color="themeBlue" [checked]="filterType.isCompleted" (click)="updateOption(false, false, false, true)" mode="md"></ion-checkbox>
      </ion-item>
    </ion-list>
  `
})
export class MatchPopoverPage {
  filterType: FilterType;

  constructor(public viewCtrl: ViewController, private navParams: NavParams) {
  }

  ngOnInit() {
    console.log("ngOnInit");
    console.log(this);
    console.log(this.navParams);
    console.log(this.navParams.data);
    this.filterType = this.navParams.get('filterType');
  }

  updateOption(isFavorite: boolean, isNotStarted: boolean, isCurrentlyPlaying: boolean,
      isCompleted: boolean) {
    if (isFavorite) {
      this.filterType.isFavorite = !this.filterType.isFavorite;
    } else if (isNotStarted) {
      this.filterType.isNotStarted = !this.filterType.isNotStarted;
    } else if (isCurrentlyPlaying) {
      this.filterType.isCurrentlyPlaying = !this.filterType.isCurrentlyPlaying;
    } else if (isCompleted) {
      this.filterType.isCompleted = !this.filterType.isCompleted;
    }
    this.navParams.get('updateFilterClicked')();
    // Close the popover
    //this.close();
  }

  close() {
    this.viewCtrl.dismiss(this.filterType);
  }
}

export class FilterType {
  isFavorite: boolean;
  isNotStarted: boolean;
  isCurrentlyPlaying: boolean;
  isCompleted: boolean;

  constructor(isFavorite : boolean, isNotStarted: boolean, isCurrentlyPlaying: boolean,
      isCompleted: boolean) {
    this.isFavorite = isFavorite;
    this.isNotStarted = isNotStarted;
    this.isCurrentlyPlaying = isCurrentlyPlaying;
    this.isCompleted = isCompleted;
  }

  getFavorite(): boolean {
    return this.isFavorite;
  }

  isEnabled(): boolean {
    return this.isFavorite || this.isNotStarted || this.isCurrentlyPlaying || this.isCompleted;
  }
}



// WEBPACK FOOTER //
// ./src/pages/match/popover.ts